import { TweenLite } from "gsap";
import { AudioManager, Track } from "../../AudioManager";
import { BalanceChangeParams, ClientState } from "../../ClientState";

import { ISystemContext } from "../../Context/SystemContext";
import { ITimeout } from "../../Context/Timeout";
import { GameSession } from "../../GameSession";

import { AddMouseDownListener, CreateElement, Log, LogGroup, Measure, Rect, Point, SetStyles, Size, TranslateScreen2To1, TranslateScreen3To1 } from "../.././MyHelpers";
import { JackpotLevel, SimpleSlotGameState } from "../../api";
import { IInterval } from "../../Context/Interval";
import { MyVideo } from "../../MyVideo";
import { CSSResource } from "../../ResourceManager/CSSResource";
import { FontResource } from "../../ResourceManager/FontResource";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { Resourceful2 } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { VideoResource2 } from "../../ResourceManager/VideoResource";
import { RobotPlay } from "../../RobotPlay";
import { ScreenProtocolScope } from "../../ScreenProtocol";
import { service } from "../../services";
import { Settings } from "../../Settings";
import { TranslatedLocation, Translator } from "../../Translator";
import { ZIndex } from "../../ZIndex";
import { SlotBonus } from "../Bonus/SlotBonus";
import { FreegameStates } from "../FreegameBonus/FreegameState";
import { ActionStats } from "../IHistoyGame";
import { MyCanvas } from "../MyCanvas";
import { Panel } from "../panel/panel";
import { BonusFinish, BonusPickElement, BonusPickReveal, BonusRevealRemaining, BonusTotalResult, IBonusStartConfig, RunResultMessage } from "../SlotGame";
import { ChangeSpeedParams } from "../SlotGameType1";
import { SlotGameType1Shared } from "../SlotGameType1Shared";
import { CanvasSprite, CanvasSpriteSizing } from "../Sprite/CanvasSprite";
import { Sprite } from "../Sprite/Sprite";
import { StateChange, StateMachine } from "../StateMachine";
import { LevelInfo1, LevelInfo2, LevelInfo3, LevelInfo4, LevelInfoMessage } from "./LevelInfo";
import { IPickBonusAction } from "./PickBonus2";
import { PickBonusElement } from "./PickBonusElement";
import { PickBonusCashReward, PickBonusJackpotReward, PickBonusParams, PickBonusPickElementParams, PickBonusRevealRemaining, PickBonusRevealValue, PickBonusReward } from "./PickBonusParams";
import { PickBonusSession } from "./PickBonusSession";
import { PickBonusState } from "./PickBonusState";
import { PickBonusMessages } from "./PickMessage";
import { PickSprite } from "./PickSprite";

export class PickBonusElemGeometry {
	public displaySize: Size = null;
	public pickRect: Rect = null;
	public awardRect: Rect = null;

	public constructor(displaySize: Size, pickRect: Rect, awardRect: Rect) {
		this.displaySize = displaySize;
		this.pickRect = pickRect;
		this.awardRect = awardRect;
	}
}

export enum CommetReason
{
	Pick,
	JpWin,
	Reel,
}

export class PickRow
{
	public view: HTMLElement = null;
	public picks: PickBonusElement[] = [];
}

export class PickBonus extends SlotBonus implements Resourceful2
{
	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
		throw new Error("Method not implemented.");
	}

	public override CreateTransitionPixi(): void {
		//throw new Error("Method not implemented.");
		//this.transitionView.CreateTrasnitionPixi();
	}
	public override DestroyTransition(): void {
		//throw new Error("Method not implemented.");
		//this.transitionView.DestroyTransitoonPixi();
	}

	protected override parentresid: ResourceIdentifier = null;
	protected override resid: ResourceIdentifier = null;
	protected params: PickBonusParams = null;
	protected view: HTMLElement = null;
	protected name:string = "";
	protected session: PickBonusSession = null;
	protected audio: AudioManager = null;
	protected picks: PickBonusElement[] = [];
	protected picksCurrentPage: PickBonusElement[] = [];
	protected revealed: number = 0;
	protected pickedIndex: number = -1;
	protected pickedAward: PickBonusReward = null;
	protected picked_animEnded: boolean = false;
	protected picked_awardSet: boolean = false;
	protected remaining_animEnded: boolean = false;
	protected remaining_awardsSet: boolean = false;
	protected pickContainer:HTMLElement = null;
	protected pickRows: PickRow[] = null;

	// protected winContainer:HTMLElement = null;
	protected totalWinText: HTMLElement = null;
	protected finalMessageContainer: HTMLElement = null;
	//protected jackpotContainer: HTMLElement = null;
	protected panel: Panel;
	protected rowLength: number =0;
	/* protected jp1Image:ImageResource = null;
	protected jp2Image:ImageResource = null;
	protected jp3Image:ImageResource = null;
	protected jp4Image:ImageResource = null; */
	/*protected jp1Logo:HTMLElement = null;
	protected jp2Logo:HTMLElement = null;
	protected jp3Logo:HTMLElement = null;
	protected jp4Logo:HTMLElement = null;*/
	protected nextPage:boolean;
	//protected pickJackpots:Map<string,PickJackpot> = new Map<string,PickJackpot>();
	protected pickCometSprite:CanvasSprite = null;
	protected blueCommetSprite:CanvasSprite = null;
	protected redCommetSprite:CanvasSprite = null;
	protected greenCommetSprite:CanvasSprite = null;
	protected whiteCommetSprite:CanvasSprite = null;

	protected pickSprite:PickSprite = null;
	protected time:number = 0;
	protected nextToBeRevealed:number = 0;
	protected stateMachine: StateMachine<PickBonusState> = null;
	//protected cometSize:Size = null;
	//private transition: SceneTransition = null;
	protected introMessageContainer: HTMLElement = null;
    protected logo: HTMLElement = null;
	protected pot: HTMLElement = null;
	protected bonus: HTMLElement = null;
	protected header: HTMLElement = null;
	protected levelInfo: HTMLElement = null;
	protected instruction: HTMLElement = null;
	protected symbol: HTMLElement = null;
	protected footer: HTMLElement = null;

	protected pickImage:ImageResource = null;
	protected potImage:ImageResource = null;
	protected bonusImage:ImageResource = null;

	protected translator:Translator;
	public translatedMessage; 

	protected finalMessage: TranslatedLocation = null;

	protected cometMap: Map<string,CanvasSprite> = new Map<string,CanvasSprite>();

	protected cometReason:CommetReason = null;
	protected _cometToPlayCanvas: CanvasSprite = null;
	protected get cometToPlayCanvas(): CanvasSprite {
		return this._cometToPlayCanvas;
	}
	protected set cometToPlayCanvas(value: CanvasSprite) {
		if (value == null) debugger;
		this._cometToPlayCanvas = value;
	}

	protected levelInfoMessagesMap: Map<number,LevelInfoMessage> = new Map<number,LevelInfoMessage>();
	protected levelInfoMessage:LevelInfoMessage = null;
	protected basepath: string = Settings.ResourcesFolder + "multigame/slot/common/resources/voice/";

	protected robotPlay: RobotPlay = null;
	protected demoMessage:HTMLElement = null;

	protected BalanceDiv:HTMLElement = null;
	protected clientState:ClientState=null;
	//video win 
	// protected div:HTMLElement=null;
	// protected divRed:HTMLElement=null;
	// protected divGreen:HTMLElement=null;
	// protected divBlue:HTMLElement=null;
	
	// protected video:HTMLVideoElement=null;
	// protected videoRed:HTMLVideoElement=null;
	// protected videoBlue:HTMLVideoElement=null;
	// protected videoGreen:HTMLVideoElement=null;

	// protected transitionView:HTMLElement=null;
	// protected videotransition:HTMLVideoElement=null;

	//CREATE DIV TO TITLE 
	//protected titleSrpite:HTMLElement=null;
	protected titleSprite: CanvasSprite = null;


	protected jpSpriteMap: Map<string, Sprite> = new Map<string, Sprite>();

	protected systemContext: ISystemContext;
	protected pickwin1SoundTimer: IInterval;
	protected pickbonuswinSoundTimer: IInterval;

	protected BonusName(): string
	{
		return "PickBonus";
	}

	constructor(gameName: string, params: PickBonusParams)
	{
		super(gameName, params);

		this.stateMachine = new StateMachine<PickBonusState>(PickBonusState.Idle, this.logGroup, (state: PickBonusState) => PickBonusState[state]);

		this.session = new PickBonusSession();
		
		this.name = gameName;
		this.parentresid = params.resid;
		this.resid = params.resid.Add(this.bonusName);

		this.systemContext = params.systemContext.CreateSubContext(this.bonusName);

		this.params = params;
		this.panel = params.panel;
		this.audio = params.audio;
		this.session.currentPage = 0;
		this.translator=params.translator;
		this.robotPlay = params.robotPlay;
		
		//add balance
		this.clientState=params.clientState;
		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.classList.add(this.bonusName);
		//this.view.style.zIndex="3";

		this.stateMachine.SetCallback(PickBonusState.IntroMessage, StateChange.Begin, () => this.OnIntroMessageBegin());
		this.stateMachine.SetCallback(PickBonusState.IntroMessage, StateChange.End, () => this.OnIntroMessageEnd());

		this.stateMachine.SetCallback(PickBonusState.PagePrepare, StateChange.Begin, () => this.OnPagePrepareBegin());
		
		this.stateMachine.SetCallback(PickBonusState.LevelMessage, StateChange.Begin, () => this.OnLevelMessageBegin());
		this.stateMachine.SetCallback(PickBonusState.LevelMessage, StateChange.End, () => this.OnLevelMessageEnd());
		//this.stateMachine.SetCallback(FreegameStates.Pick, StateChange.End, () => this.OnPickEnd());
		this.stateMachine.SetCallback(PickBonusState.Pick, StateChange.Begin, () => this.OnPickBegin());



		this.stateMachine.SetCallback(PickBonusState.FinalMessage, StateChange.Begin, () => this.OnFinalMessageBegin());
		this.stateMachine.SetCallback(PickBonusState.FinalMessage, StateChange.End, () => this.OnFinalMessageEnd());

		//this.stateMachine.SetCallback(PickBonusState.PickedMessage, StateChange.Begin, () => this.OnPickedMessageBegin());
		//this.stateMachine.SetCallback(PickBonusState.PickedMessage, StateChange.End, () => this.OnPickedMessageEnd());

		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.CommetDestination.msgname, (m) => this.CommetRectDest((<PickBonusMessages.CommetDestination>m)), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.CommetJp.msgname, (m) => this.CommetJP((<PickBonusMessages.CommetJp>m)), this.screenProtocolScope);
		//this.levelInfoMessage = new LevelInfoMessage(this.resid,this.translator,this.params);

		this.levelInfoMessagesMap.set(0,new LevelInfo1(this.resid,this.translator,this.params));
		this.levelInfoMessagesMap.set(1,new LevelInfo2(this.resid,this.translator,this.params));
		this.levelInfoMessagesMap.set(2,new LevelInfo3(this.resid,this.translator,this.params));
		this.levelInfoMessagesMap.set(3,new LevelInfo4(this.resid,this.translator,this.params));

		if(params.slotGameMeta.Demo == true)
		{
			//demo message
			this.demoMessage = document.createElement("div");
			this.demoMessage.classList.add("demo-message");
			SetStyles(this.demoMessage,
			{
				position:"absolute",
				top:"8%",
				left:"86%",
				width:"16%",
				height:"8%",
				fontSize:"99px",
				letterSpacing:"5px",
				fontFamily:"NotoSansDisplay-ExtraBold",
				color:"rgba(255, 0, 0, 1)",
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				transform: "rotate(45deg)",
			})
			
			this.demoMessage.innerHTML = "DEMO";
		}

		
		this.BalanceDiv=document.createElement("div");
		this.BalanceDiv.classList.add("balance");

		SetStyles(this.BalanceDiv,
			{
				height: "100px",
				width: "240px",
				fontFamily: "NotoSansDisplay-SemiBold",
				background: "radial-gradient(circle, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4))",
				borderRadius: "10px",
				borderTop: "none",
				borderRight: "2px solid transparent",
				borderBottom: "2px solid rgb(221, 221, 221)",
				borderLeft: "2px solid transparent",
				borderImage: "initial",
				boxShadow: "rgb(0, 0, 0) 0px 2px 4px inset, rgb(255, 255, 255) 0px -2px 2px, rgb(255, 255, 255) 0px 2px 0px",
				justifyContent: "center",
				alignItems: "center",
				textAlign: "center",
				display: "grid",
				position:"absolute",
				bottom:"10px",	
				color: "white",
   				textShadow: "blue 0px 0px 10px, blue 0px 0px 20px, blue 0px 0px 30px, blue 0px 0px 40px",
				fontSize: "30px",
				left:"840px",
				
			});
			let BalanceText=document.createElement("div");
			BalanceText.classList.add("balancetext");
		
			SetStyles(BalanceText,
				{
					color: "yellow",
   				
					textShadow: "blue 0px 0px 10px, blue 0px 0px 20px, blue 0px 0px 30px, blue 0px 0px 40px",
					height: "50px",
					width: "240px",
					fontSize: "30px",	
				});

				let balancevalue=document.createElement("div");
				balancevalue.classList.add("balancetext");
		
			SetStyles(balancevalue,
				{
					color: "white",
   				
					textShadow: "blue 0px 0px 10px, blue 0px 0px 20px, blue 0px 0px 30px, blue 0px 0px 40px",
					height: "50px",
					width: "240px",
					fontSize: "30px",	
				});

				BalanceText.appendChild(this.translator.Anchor(() => this.translator.t.balance));
       
				
		this.BalanceDiv.appendChild(BalanceText);
		this.BalanceDiv.appendChild(balancevalue);
		
		this.clientState.AddOnBalanceChangedCallback((balanceParams: BalanceChangeParams)=> balancevalue.innerHTML = service.moneyFormatter.FormatCurrency(balanceParams.newBalance));

		//this.BalanceDiv.innerHTML = "Credit " +this.moneyFormatter.FormatCredit(this.clientState.Balance());
		
		
		this.view.appendChild(this.BalanceDiv);

		this.pickwin1SoundTimer = this.systemContext.TimingContext().CreateInterval("pickwin1SoundTimer", 2000, () => {
			this.audio.PlayLoop(this.resid.ScopedResourceName("pickwin1"));
		});

		this.pickbonuswinSoundTimer = this.systemContext.TimingContext().CreateInterval("pickbonuswinSoundTimer", 500, () => {
			this.audio.Play(this.resid.ScopedResourceName("pickbonuswin"));
		});
	}


	protected bonusFinished: boolean = false;

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		// await SlotGameType1Shared.Instance().ResourcesPrepare(loadingStage, resourceManager , this.params.jackpotRequired);
		await this.LoadFont(resourceManager);
		await this.BasePrepare(resourceManager);
		await this.PicksPrepare(resourceManager);
		await this.PreparePickContainer(resourceManager);
		

		////////////////////
		//this.levelInfoMessage.PrepareResources(resourceManager);

		for(let i = 0; i < this.levelInfoMessagesMap.size; i++)
		{
			let curretnLevelMessage = this.levelInfoMessagesMap.get(i);
			curretnLevelMessage.PrepareResources(resourceManager);
		}


		this.AudioPrepare(resourceManager);
		this.BigWinPrepare(resourceManager);
		this.PrepareVideos(resourceManager);
	}

	protected PrepareVideos(resourceManager: IWriteOnlyResourceManager): void
	{
		//resourceManager.AddGlobal(new VideoResource(this.params.commonBonusResourcesBasePath + "video/transition", ResourceIdentifier.Global.Add("PickBonus").Add("Transition"), LogGroup.Global.Add("PickBonus").Add("Transition")));

		resourceManager.AddGlobal(new VideoResource2({
			resid: ResourceIdentifier.Global.Add("PickBonus").Add("Transition"),
			logGroup: LogGroup.Global.Add("PickBonus").Add("Transition"),
			src: this.params.commonBonusResourcesBasePath + "video/transition",
			unloadOnEnd: true
		}));

		//resourceManager.AddGlobal(new VideoResource(Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/video/white", ResourceIdentifier.Global.Add("jp4"), LogGroup.Global.Add("JP4Video")));

		resourceManager.AddGlobal(new VideoResource2({
			resid: ResourceIdentifier.Global.Add("jp4"),
			logGroup: LogGroup.Global.Add("JP4Video"),
			src: Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/video/white",
			unloadOnEnd: true
		}));

		//resourceManager.AddGlobal(new VideoResource(Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/video/red", ResourceIdentifier.Global.Add("jp3"), LogGroup.Global.Add("JP3Video")));

		resourceManager.AddGlobal(new VideoResource2({
			resid: ResourceIdentifier.Global.Add("jp3"),
			logGroup: LogGroup.Global.Add("JP3Video"),
			src: Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/video/red",
			unloadOnEnd: true
		}));
		
		//resourceManager.AddGlobal(new VideoResource(Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/video/green", ResourceIdentifier.Global.Add("jp2"), LogGroup.Global.Add("JP2Video")));

		resourceManager.AddGlobal(new VideoResource2({
			resid: ResourceIdentifier.Global.Add("jp2"),
			logGroup: LogGroup.Global.Add("JP2Video"),
			src: Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/video/green",
			unloadOnEnd: true
		}));

		//resourceManager.AddGlobal(new VideoResource(Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/video/blue", ResourceIdentifier.Global.Add("jp1"), LogGroup.Global.Add("JP1Video")));

		resourceManager.AddGlobal(new VideoResource2({
			resid: ResourceIdentifier.Global.Add("jp1"),
			logGroup: LogGroup.Global.Add("JP1Video"),
			src: Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/video/blue",
			unloadOnEnd: true
		}));
	}

	protected VideosLoaded(resourceManager: IReadOnlyResourceManager): void
	{
		// make sure transition covers everything
		let transition: MyVideo = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("PickBonus").Add("Transition")).video;
		SetStyles(transition.View(), {position: "absolute", top: "0px", left: "0px", zIndex: "" + ZIndex.BonusTransition});
		this.systemContext.SharedVideoContext().AddVideo(transition);

		// make sure jackpot videos loop
		let jp4 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp4")).video;
		//jp4.video.loop = true;
		SetStyles(jp4.View(), {position: "absolute", top: "0px", left: "0px"});
		this.systemContext.SharedVideoContext().AddVideo(jp4);

		let jp3 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp3")).video;
		//jp3.video.loop = true;
		SetStyles(jp3.View(), {position: "absolute", top: "0px", left: "0px"});
		this.systemContext.SharedVideoContext().AddVideo(jp3);

		let jp2 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp2")).video;
		//jp2.video.loop = true;
		SetStyles(jp2.View(), {position: "absolute", top: "0px", left: "0px"});
		this.systemContext.SharedVideoContext().AddVideo(jp2);

		let jp1 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp1")).video;
		//jp1.video.loop = true;
		SetStyles(jp1.View(), {position: "absolute", top: "0px", left: "0px"});
		this.systemContext.SharedVideoContext().AddVideo(jp1);
	}

	public LoadFont(resourceManager: IWriteOnlyResourceManager)
	{
		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "vapor.otf", this.resid.ScopedResourceName("award")));
	}


	public AudioPrepare(resourceManager: IWriteOnlyResourceManager)
	{
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/background" + Settings.audioFormat, this.resid.ScopedResourceName("background")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/transition" + Settings.audioFormat, this.resid.ScopedResourceName("transition")));
		//Last win audio
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/pickwin1" + Settings.audioFormat, this.resid.ScopedResourceName("pickwin1")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/chance" + Settings.audioFormat, this.resid.ScopedResourceName("chances")));
		
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/pick" + Settings.audioFormat, this.resid.ScopedResourceName("pick")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/remaining" + Settings.audioFormat, this.resid.ScopedResourceName("remaining")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/comet" + Settings.audioFormat, this.resid.ScopedResourceName("comet")));
		//this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/fireworksBlow" + Settings.audioFormat,this.resid.ScopedResourceName("fireworksBlow")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/pickbonuswin" + Settings.audioFormat,this.resid.ScopedResourceName("pickbonuswin")));
		//load all audio to pick JP
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/jp1" + Settings.audioFormat, this.resid.ScopedResourceName("jp1")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/jp2" + Settings.audioFormat, this.resid.ScopedResourceName("jp2")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/jp3" + Settings.audioFormat, this.resid.ScopedResourceName("jp3")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/jp4" + Settings.audioFormat, this.resid.ScopedResourceName("jp4")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/diamond" + Settings.audioFormat, this.resid.ScopedResourceName("diamond")));
		
		//coin audio wi 
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/coin" + Settings.audioFormat, this.resid.ScopedResourceName("coin")));

		//load new fireworks for jp4 and jp3
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/Fireworks" + Settings.audioFormat, this.resid.ScopedResourceName("Fireworks")));

		//load new claps sound for jp4 and jp3
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/applause" + Settings.audioFormat, this.resid.ScopedResourceName("applause")));
	

		//load full version backgroundsound in 4 level 
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/bonustriggered" + Settings.audioFormat, this.resid.ScopedResourceName("triggered")));
		//load voice to win 

		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/claps" + Settings.audioFormat, this.resid.ScopedResourceName("claps")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/bigwin" + Settings.audioFormat, this.resid.ScopedResourceName("bigwin")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/winner" + Settings.audioFormat, this.resid.ScopedResourceName("winner")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/win" + Settings.audioFormat, this.resid.ScopedResourceName("win")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/clapswhite" + Settings.audioFormat, this.resid.ScopedResourceName("clapswhite")));
		//Add new Famale Voice
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/DiamondFamale" + Settings.audioFormat, this.resid.ScopedResourceName("DiamondFamale")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/RubyFamale" + Settings.audioFormat, this.resid.ScopedResourceName("RubyFamale")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/EmeraldFamale" + Settings.audioFormat, this.resid.ScopedResourceName("EmeraldFamale")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/SapphireFamale" + Settings.audioFormat, this.resid.ScopedResourceName("SapphireFamale")));
		
		//load jackpot sound effect
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/Emeraldwin" + Settings.audioFormat, this.resid.ScopedResourceName("Emeraldwin")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/Rubywin" + Settings.audioFormat, this.resid.ScopedResourceName("Rubywin")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/Diamondwin" + Settings.audioFormat, this.resid.ScopedResourceName("Diamondwin")));
		//Load Voice Diamond POT
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/diamond-pot" + Settings.audioFormat, this.resid.ScopedResourceName("diamond-pot")));
		//LOAD LIGHTING
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/transitionLight" + Settings.audioFormat, this.resid.ScopedResourceName("transitionLight")));
	

		
	}

	public GetSession(): GameSession {
		return null;
	}

	protected BasePrepare(resourceManager: IWriteOnlyResourceManager): void {

		//common resources
		resourceManager.Add(new CSSResource(this.params.commonBonusResourcesBasePath +  "PickBonus.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));
		//Background Message
		resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath + "message_background.png", this.resid.ScopedResourceName(["messagepanel", "image"])));

		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "comet", ResourceIdentifier.Global.Add("PickBonus").Add("Commet"), true, LogGroup.Global.Add("PickBonus").Add("Commet"), true))
		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "blueComet", ResourceIdentifier.Global.Add("PickBonus").Add("BlueCommet"), true, LogGroup.Global.Add("PickBonus").Add("BlueCommet"), true))
		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "redComet", ResourceIdentifier.Global.Add("PickBonus").Add("RedCommet"), true, LogGroup.Global.Add("PickBonus").Add("RedCommet"), true))
		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "greenComet", ResourceIdentifier.Global.Add("PickBonus").Add("GreenCommet"), true, LogGroup.Global.Add("PickBonus").Add("GreenCommet"), true))
		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "whiteComet", ResourceIdentifier.Global.Add("PickBonus").Add("WhiteCommet"), true, LogGroup.Global.Add("PickBonus").Add("WhiteCommet"), true))

		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "Diamond_Pot", ResourceIdentifier.Global.Add("PickBonus").Add("Diamond_Pot"), true, LogGroup.Global.Add("PickBonus").Add("Diamond_Pot"), true))

		resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath + "background.jpg", this.resid.ScopedResourceName(["background", "image"])));
		//Grid for Picks
		resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath + "gold_grid.png", this.resid.ScopedResourceName(["gold_grid", "image"])));

		//LOAD DIAMOND POT SPRITE
		//resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "transition", ResourceIdentifier.Global.Add("PickBonus").Add("Transition"), true, LogGroup.Global.Add("PickBonus").Add("Transition"), true))
		//resourceManager.Add(new VideoResource(this.params.commonBonusResourcesBasePath + "video/transition", this.resid.Add("transition"), this.logGroup.Add("transition")));
	
		


	}

	protected gameBackground: ImageResource = null;
	protected async BaseLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		this.gameBackground= resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"]));
		this.view.style.backgroundImage = this.gameBackground.CssBackground();
	}

	/*
	protected PrepareFonts(resourceManager: ResourceManager): void {
		resourceManager.Add(new FontResource(this.params.gameResourcesBasePath + "huggable.ttf", "." + this.resid.ScopedResourceName("font") ));
		resourceManager.Add(new FontResource(this.params.gameResourcesBasePath + "28 Days Later.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
	}*/

	protected introMessage:HTMLElement = null;

	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {

		// await SlotGameType1Shared.Instance().ResourcesLoaded(loadingStage, resourceManager , this.params.jackpotRequired);

		//this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"])).CssBackground();
		await this.BaseLoaded(resourceManager);
		let messagePanel:ImageResource = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["messagepanel", "image"]));
		
		await this.PicksLoaded(resourceManager);
		
		if(this.params.slotGameMeta.Demo == true)
		{
			this.view.appendChild(this.demoMessage);
		}

		this.finalMessageContainer = document.createElement("div");
		this.finalMessageContainer.classList.add(this.resid.Scope());
		this.finalMessageContainer.classList.add("finalMessageContainer");
		

		
		this.finalMessageContainer.innerHTML =
		`<div class="finalMessage" style="postion:absolute;"></div>`; 
		
        

		
		SetStyles(this.finalMessageContainer,
		{
			
			 top: "25%",
			left: "19%",
			width: "1200px",
			height: "600px",
			//borderRadius: "50px",
			background:messagePanel.CssBackground(),
			backgroundPosition:"center",
			backgroundRepeat:"no-repeat",
			backgroundSize:"contain",
			fontFamily: "NotoSansDisplay-BoldItalic",
			backgroundColor: "rgba(0,0,0,0)",
			color: "white",
			fontSize: "80px",
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			textAlign: "center",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
		
			//textShadow:"0px 0px 10px blue, 0px 0px 20px blue, 0px 0px 30px blue, 0px 0px 40px blue",
				
			position:"absolute",
			zIndex: ""+ ZIndex.BonusCofirmMessage,

		});
		
		AddMouseDownListener(this.finalMessageContainer, () =>
		{
			if (this.stateMachine.State() == PickBonusState.FinalMessage) {
				// Log.Debug(this.logGroup, "Final message confirmed");
				this.stateMachine.ChangeState(PickBonusState.Idle);
			}
			else {
				Log.Error(this.logGroup, "Can't confirm final message, current state: " + FreegameStates[this.stateMachine.State()] + ", required state: " + FreegameStates[FreegameStates.FinalMessage]);
			}
		});

		this.finalMessage = this.translator.Translate(() => this.translator.t.winbonus(service.moneyFormatter.FormatCurrency(this.session.totalWin)));
		this.finalMessageContainer.querySelector(".finalMessage").appendChild(this.finalMessage.location);
		

		//this.transition = new SceneTransition(this.logGroup, this.params.screenSize, new CanvasSprite(resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("Transition")).sprite.Copy(), this.params.screenSize));



		//this.BaseLoaded(resourceManager);
		//this.PrepareLevelMessage(resourceManager);

		for(let i = 0; i < this.levelInfoMessagesMap.size; i++)
		{
			this.levelInfoMessagesMap.get(i).ResourcesLoaded(resourceManager);
		}


		this.introMessageContainer = document.createElement("div");
		this.introMessageContainer.classList.add("introMessageContainer");
		this.introMessageContainer.style.position ="absolute";
		this.introMessageContainer.style.top ="0px";
		this.introMessageContainer.style.left = "0px";
		this.introMessageContainer.style.width ="100%";
		this.introMessageContainer.style.height ="100%";
		this.introMessageContainer.style.zIndex = ""+ ZIndex.BonusCofirmMessage;
		this.introMessageContainer.style.display="flex";
		this.introMessageContainer.style.justifyContent="center";
	/* 	this.introMessageContainer.style.alignContent="center";
		this.introMessageContainer.style.alignSelf="center"; */
		this.introMessageContainer.style.alignItems="center";
		
		
		
	
	
		AddMouseDownListener(this.introMessageContainer, () =>
		{
			if (this.stateMachine.State() == PickBonusState.LevelMessage) {
				// Log.Debug(this.logGroup, "Start message confirmed");
				//this.stateMachine.ChangeState(PickBonusState.PagePrepare);
				this.stateMachine.ChangeState(PickBonusState.Pick);
				this.HideContainer(this.introMessageContainer);
				this.levelInfoMessagesMap.get(this.session.currentPage).Hide();
				//this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
				//this.audio.Stop(this.resid.ScopedResourceName("chances"));
			}
			else {
				Log.Error(this.logGroup, "Can't confirm start message, current state: " + FreegameStates[this.stateMachine.State()] + ", required state: " + FreegameStates[FreegameStates.FinalMessage]);
			}

		});
        
		//this.introMessageContainer.appendChild(this.introMessage);
		for(let i = 0; i< this.levelInfoMessagesMap.size; i ++ )
		{
			this.introMessageContainer.appendChild(this.levelInfoMessagesMap.get(i).View());
		}

		this.view.appendChild(this.pickContainer);

		let final:HTMLElement= document.createElement("div");
		final.appendChild(this.finalMessageContainer);
		final.style.width="100%";
		final.style.height="100%";
		final.style.display="flex";
		this.view.appendChild(final);
		this.view.appendChild(this.introMessageContainer);
		

		
		this.SpriteLoaded(resourceManager);
		this.BigWinLoaded(resourceManager);

		this.titleSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("Diamond_Pot")).sprite, canvasSize: new Size(1920, 400)});
				
		
		//this.titleSprite.canvas.view.style.zIndex="1000";
		this.titleSprite.canvas.view.style.zIndex = ""+ ZIndex.JPTitle;
		this.titleSprite.canvas.view.style.position="absolute";
		this.titleSprite.canvas.view.style.top="1287px";
		//this.transitionView.appendChild(this.titleSprite.View());



		//this.view.appendChild(this.transitionView);

		this.VideosLoaded(resourceManager);
	}

	protected BigWinPrepare(resourceManager: IWriteOnlyResourceManager): void {
	}

	protected BigWinLoaded(resourceManager: IReadOnlyResourceManager): void {
		

		// fountain to diamond
		{
			let fountainAnimation = SlotGameType1Shared.Instance().bigFountainAnimation
			fountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
			fountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		}

		// fountain to emerald
		{
			// same as sapphire
		}

		// fountain to sapphire
		{
			let fountainAnimation = SlotGameType1Shared.Instance().smallFountainAnimation;
			fountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
			fountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		}

		// fountain to ruby
		{
			let fountainAnimation = SlotGameType1Shared.Instance().mediumFountainAnimation;
			fountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
			fountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		}
	}

	protected SpriteLoaded(resourceManager: IReadOnlyResourceManager):void
	{
		this.pickCometSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("Commet")).sprite.Copy(), canvasSize: null, drawFirstFrame:  true, sizing:  CanvasSpriteSizing.Stretch});
		this.blueCommetSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("BlueCommet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch});
		this.redCommetSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("RedCommet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch});
		this.greenCommetSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("GreenCommet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch});
		this.whiteCommetSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("WhiteCommet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch});


		this.cometMap.set("pickCommet", this.pickCometSprite);
		this.cometMap.set("jp1", this.blueCommetSprite);

		//Red comet
		this.cometMap.set("jp3", this.redCommetSprite);

		//Green comet
		this.cometMap.set("jp2", this.greenCommetSprite);

		//White commet
		this.cometMap.set("jp4", this.whiteCommetSprite);


		this.cometMap.forEach((commet:CanvasSprite)=>{
			commet.View().style.position = "absolute";
			this.view.appendChild(commet.View());
			//this.cometSize = commet.Size();

			commet.AddOnCompleteCallback(()=> this.CometComplete())
			commet.Hide();
		});
	}

	protected CometComplete()
	{
		this.cometToPlayCanvas.Hide();

		if(this.cometReason == CommetReason.Pick)
		{
			this.screenProtocol.Send(new PickBonusMessages.CommetPickComplete(),this.screenProtocolScope);
			

			if(this.pickedAward.PickType==2)
			{ 	
				//play sound that pick are touch
				let jpward = this.pickedAward as PickBonusJackpotReward;
				if (jpward.JackpotCount <=4 )
				{
					
					this.audio.Play(this.resid.ScopedResourceName(jpward.JackpotName));

				}

				if (jpward.JackpotCount ==4 && jpward.JackpotName=="jp1") 
				{
					let video: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add("jp1"));
					video.View().style.display = "";
					video.Play(this.resid);
					TweenLite.set(video.View(), {autoAlpha: 1});
					
					// fadeout
					setTimeout(() => 
						TweenLite.to(video.View(), 2, {autoAlpha: 0, onComplete: () => {
							video.StopAndReset(this.resid);
							video.View().style.display = "none";
						}}
					), 3600);


					//play loop sound to pick when you win 4 pick
					setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("SapphireFamale")),1000);
					setTimeout(() =>this.audio.Play(this.resid.ScopedResourceName("claps")),3500);
					setTimeout(() =>this.audio.Play(this.resid.ScopedResourceName("win")),2500);
					//play fountainAnimation 


					SlotGameType1Shared.Instance().smallFountainAnimation.Start(this.resid);
					//stop request fountainanimation
					setTimeout(() => 
					{
						SlotGameType1Shared.Instance().smallFountainAnimation.RequestStop(this.resid);
						this.screenProtocol.Send(new PickBonusMessages.JpShowFinish(),new ScreenProtocolScope("JackpotDisplayOrtiz"));

					},4600);
					//setTimeout(() => this.audio.Stop(this.resid.ScopedResourceName("jp1")),2900);
					//send info to jackpot display 
					this.screenProtocol.Send(new PickBonusMessages.DiamondAnimation(1),new ScreenProtocolScope("JackpotDisplayOrtiz"));
					this.screenProtocol.Send(new PickBonusMessages.CommetJPComplete(),this.screenProtocolScope);
					

					// wait for showtime to finish, then go to next pick
					setTimeout(() => this.DelayedNextPick(), 4600);
				}

				if (jpward.JackpotCount ==4 && jpward.JackpotName=="jp2" ) 
				{
					let video: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add("jp2"));
					video.View().style.display = "";
					video.Play(this.resid);
					TweenLite.set(video.View(), {autoAlpha: 1});
					
					// fadeout
					setTimeout(() => 
						TweenLite.to(video.View(), 2, {autoAlpha: 0, onComplete: () => {
							video.StopAndReset(this.resid)
							video.View().style.display = "none";
						}}
					), 14000);

					//play loop sound to pick when you win 4 pick
					this.audio.Stop(this.resid.ScopedResourceName("background"));
					setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("EmeraldFamale")),2000);
					setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("winner")),3200);
					

					setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("claps")),3500);
				   //play fountainAnimation 
					SlotGameType1Shared.Instance().smallFountainAnimation.Start(this.resid);
					setTimeout(() =>this.audio.Play(this.resid.ScopedResourceName("Emeraldwin")),3000);
					
					//stop request fountainanimation
					setTimeout(() => 
					{
						SlotGameType1Shared.Instance().smallFountainAnimation.RequestStop(this.resid);
						this.screenProtocol.Send(new PickBonusMessages.JpShowFinish(),new ScreenProtocolScope("JackpotDisplayOrtiz"));
						
					},13500);
					setTimeout(() => this.audio.Stop(this.resid.ScopedResourceName("Emeraldwin")),13500);
					this.screenProtocol.Send(new PickBonusMessages.DiamondAnimation(2),new ScreenProtocolScope("JackpotDisplayOrtiz"));
					this.screenProtocol.Send(new PickBonusMessages.CommetJPComplete(),this.screenProtocolScope);
					setTimeout(() => this.audio.PlayLoop(this.resid.ScopedResourceName("background")),14000);

					// wait for showtime to finish, then go to next pick
					setTimeout(() => this.DelayedNextPick(), 14000);
					
				}
				if (jpward.JackpotCount ==4 && jpward.JackpotName == JackpotLevel.Jp3 )
				{
					let video: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add(JackpotLevel.Jp3));
					video.View().style.display = "";
					video.Play(this.resid);
					TweenLite.set(video.View(), {autoAlpha: 1});
					
					// fadeout
					setTimeout(() => 
						TweenLite.to(video.View(), 2, {autoAlpha: 0, onComplete: () => {
							video.StopAndReset(this.resid)
							video.View().style.display = "none";
						}}
					), 16500);

					this.audio.Stop(this.resid.ScopedResourceName("background"));
					//play loop sound to pick when you win 4 pick
					setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("RubyFamale")),1500);
					setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("bigwin")),4000);
					setTimeout(() =>this.audio.PlayLoop(this.resid.ScopedResourceName("Rubywin")),5000);
					setTimeout(() =>this.audio.PlayLoop(this.resid.ScopedResourceName("applause")),5000);
					
					//play firewroks
					setTimeout(() => this.audio.PlayLoop(this.resid.ScopedResourceName("Fireworks")),3000);
					//play fountainAnimation 
					SlotGameType1Shared.Instance().mediumFountainAnimation.Start(this.resid);
					
					setTimeout(() => this.audio.Stop(this.resid.ScopedResourceName("Rubywin")),16500);
					setTimeout(() => this.audio.Stop(this.resid.ScopedResourceName("Fireworks")),16500);
					setTimeout(() => this.audio.Stop(this.resid.ScopedResourceName("applause")),16500);
					setTimeout(() => this.audio.PlayLoop(this.resid.ScopedResourceName("background")),17000);
					
					//stop request fountainanimation
					setTimeout(() =>{
						SlotGameType1Shared.Instance().mediumFountainAnimation.RequestStop(this.resid);
						this.screenProtocol.Send(new PickBonusMessages.JpShowFinish(),new ScreenProtocolScope("JackpotDisplayOrtiz"));
					},16500);
					this.screenProtocol.Send(new PickBonusMessages.DiamondAnimation(3),new ScreenProtocolScope("JackpotDisplayOrtiz"));
					this.screenProtocol.Send(new PickBonusMessages.CommetJPComplete(),this.screenProtocolScope);

					setTimeout(() => service.api.jpShowStart(
					{
						jackpotName: JackpotLevel.Jp3,
						duration: 18000,
						win: jpward.WinAmount.InCents
					}),  1000);
				
					// wait for showtime to finish, then go to next pick
					setTimeout(() => this.DelayedNextPick(), 18000);

				

				}

				if (jpward.JackpotCount == 4 && jpward.JackpotName == JackpotLevel.Jp4 )
				{
					let video: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add(JackpotLevel.Jp4));
					video.View().style.display = "";
					video.Play(this.resid);
					TweenLite.set(video.View(), {autoAlpha: 1});
					
					// fadeout
					setTimeout(() => 
						TweenLite.to(video.View(), 2, {autoAlpha: 0, onComplete: () => {
							video.StopAndReset(this.resid);
							video.View().style.display = "none";
						}}
					), 55000);
					
					//play  loop sound to pick when you win 4 pick and play fountain
					this.audio.Stop(this.resid.ScopedResourceName("background"));
					
					SlotGameType1Shared.Instance().bigFountainAnimation.Start(this.resid);
					setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("DiamondFamale")),2500);
					setTimeout(() =>this.audio.Play(this.resid.ScopedResourceName("bigwin")),5000);
					setTimeout(() =>this.audio.PlayLoop(this.resid.ScopedResourceName("Fireworks")),6500);
					setTimeout(() =>this.audio.Play(this.resid.ScopedResourceName("Diamondwin")),6500);
					setTimeout(() =>this.audio.PlayLoop(this.resid.ScopedResourceName("applause")),6500);
					
					setTimeout(() =>this.audio.Stop(this.resid.ScopedResourceName("Fireworks")),55000);
					//QUIT LOOP DIAMONW WIN PLAY ONE TIME 
					//setTimeout(() =>this.audio.Stop(this.resid.ScopedResourceName("Diamondwin")),55000);
					
					setTimeout(() =>{
						 SlotGameType1Shared.Instance().bigFountainAnimation.RequestStop(this.resid);
						 this.screenProtocol.Send(new PickBonusMessages.JpShowFinish(),new ScreenProtocolScope("JackpotDisplayOrtiz"));
					},55000);
					setTimeout(() => this.audio.Stop(this.resid.ScopedResourceName("applause")),55000);
					setTimeout(() => this.audio.PlayLoop(this.resid.ScopedResourceName("background")),60000);
				
					this.screenProtocol.Send(new PickBonusMessages.DiamondAnimation(4),new ScreenProtocolScope("JackpotDisplayOrtiz"));
					this.screenProtocol.Send(new PickBonusMessages.CommetJPComplete(),this.screenProtocolScope);
					
					setTimeout(() => service.api.jpShowStart(
					{
						jackpotName: JackpotLevel.Jp4,
						duration: 60000,
						win: jpward.WinAmount.InCents
					}),  1000);
				
					// wait for showtime to finish, then go to next pick
					setTimeout(() => this.DelayedNextPick(), 60000);
					
				} 
			}


			else if (this.pickedAward.PickType == 1)
			{
				//play sound whe you pick cash 
				//setTimeout(() =>this.audio.Play(this.resid.ScopedResourceName("coin")),500);
				//this.audio.Play(this.resid.ScopedResourceName("comet"));
				

			}

			if(this.pickedAward.PickType == 2 && (this.pickedAward as PickBonusJackpotReward).JackpotCount == 4)
			{
				



			}
			else
			{	

				this.NextPick();
			}

		}

		else if(this.cometReason == CommetReason.JpWin)
		{
			
		
		}
	}

	protected DelayedNextPick(): void
	{
		//this.screenProtocol.Send(new PickBonusMessages.CommetJPComplete(),this.screenProtocolScope);
		this.screenProtocol.Send(new PickBonusMessages.JpShowFinish(),this.screenProtocolScope);
		this.NextPick();
	}
	

	protected CommetJP(message:PickBonusMessages.CommetJp)
	{
		let srcRect = TranslateScreen3To1(message.srcRect);
		let destRect = TranslateScreen2To1(message.destRect);

		this.StartCommet(srcRect.Center(), destRect.Center(), CommetReason.JpWin);
	}

	protected winRect: Rect = null;
	protected CommetRectDest(message:PickBonusMessages.CommetDestination):void
	{
		this.winRect = TranslateScreen2To1(message.destRect);
		this.TryDisplayCommet();
	}

	protected awardReveled:boolean = false;
	protected TryDisplayCommet()
	{
		if(this.winRect !=null && this.awardReveled == true)
		{
			//center of free space for diamond
			/* let centerY:number = this.winRect.y + this.winRect.height/2 ;
			let centerX:number = this.winRect.x + this.winRect.width/2 ; */
			let destCenter:Point =  this.winRect.Center();

			/* let row: number = Math.round((this.pickedIndex/this.pickRows[0].picks.length));
			let symbolX: number = Math.round((this.pickedIndex % this.pickRows[row].picks.length)); */

			let point: Point = Measure(this.picksCurrentPage[this.pickedIndex].View(), this.view); 

			//center of picked element
			let pick:Point = new Point(
				this.picksCurrentPage[this.pickedIndex].PickRect().x + 
				point.x+
				/* this.pickContainer.offsetLeft +
				(symbolX * this.picksCurrentPage[this.pickedIndex].PickRect().width) + */
				//this.picksCurrentPage[this.pickedIndex].DisplayRect().x + 
				this.picksCurrentPage[this.pickedIndex].PickRect().width/2,

				this.picksCurrentPage[this.pickedIndex].PickRect().y + 
				point.y+
				/* this.pickContainer.offsetTop +
				row * this.picksCurrentPage[this.pickedIndex].PickRect().height + */
				//this.picksCurrentPage[this.pickedIndex].DisplayRect().y + 
				this.picksCurrentPage[this.pickedIndex].PickRect().height/2
			);

			this.StartCommet(pick, destCenter, CommetReason.Pick);
		}
		
	}


	
	protected StartCommet(source:Point, dest:Point, commetReason:CommetReason)
	{
		if(this.pickedAward.PickType == 1)
		{
			this.cometToPlayCanvas = this.cometMap.get("pickCommet");
		}
		else
		{
			let cometToPlayName:string = (this.pickedAward as PickBonusJackpotReward).JackpotName;
			this.cometToPlayCanvas = this.cometMap.get(cometToPlayName);
		}
		this.cometReason = commetReason;
		//distance betwen center of pick and center of free space
		let distanceX:number = source.x - dest.x;
		let distanceY:number = source.y - dest.y;
		let distance:number = Math.sqrt(distanceX*distanceX + distanceY*distanceY); 

		//bigger animation
		let animDistance = distance + distance*0.42 + distance*0.197;

		let commetToPlaySpriteSize = this.cometToPlayCanvas.sprite.Size();
		let sizeFactor:number = animDistance / commetToPlaySpriteSize.Height;
		let newWidt:number = commetToPlaySpriteSize.Width * sizeFactor;

		//new size for sprite

		
		this.cometToPlayCanvas.SetSize(new Size(newWidt,animDistance));
		//this.cometSprite.SetSize(new Size(newWidt,animDistance));

		//angle for rotation
		let angle:number = (Math.atan2(distanceY , distanceX)* 180 / Math.PI) - 90;

		this.cometToPlayCanvas.View().style.left = (source.x - newWidt*0.45)+"px";
		this.cometToPlayCanvas.View().style.top = (source.y - animDistance + distance*0.197)+"px";

		
		this.cometToPlayCanvas.View().style.transform = "rotate("+angle+"deg)";
		this.cometToPlayCanvas.View().style.transformOrigin = "50% 87%";

		this.cometToPlayCanvas.View().style.zIndex = ""+ this.pickedZIndex+1;

		this.cometToPlayCanvas.Start(false);
		this.cometToPlayCanvas.Show();
		
		/* this.cometSprite.View().style.left = (source.x - newWidt*0.45)+"px";
		this.cometSprite.View().style.top = (source.y - animDistance + distance*0.197)+"px";

		
		this.cometSprite.View().style.transform = "rotate("+angle+"deg)";
		this.cometSprite.View().style.transformOrigin = "50% 87%";

		this.cometSprite.Start(false);
		this.cometSprite.Show(); */
		this.audio.Play(this.resid.ScopedResourceName("comet"));

	}

	protected PicksPrepare(resourceManager: IWriteOnlyResourceManager): void {
		resourceManager.Add(new SpriteResource(this.params.gameBonusResourcesBasePath + "pick_coin", this.resid.Add("pick_coin"), true, this.logGroup.Add("pick_coin"), true));
		resourceManager.Add(new SpriteResource(this.params.gameBonusResourcesBasePath + "pick_blue", this.resid.Add("pick_blue"), true, this.logGroup.Add("pick_blue"), true));
		resourceManager.Add(new SpriteResource(this.params.gameBonusResourcesBasePath + "pick_green", this.resid.Add("pick_green"), true, this.logGroup.Add("pick_green"), true));
		resourceManager.Add(new SpriteResource(this.params.gameBonusResourcesBasePath + "pick_red", this.resid.Add("pick_red"), true, this.logGroup.Add("pick_red"), true));
		resourceManager.Add(new SpriteResource(this.params.gameBonusResourcesBasePath + "pick_white", this.resid.Add("pick_white"), true, this.logGroup.Add("pick_white"), true));
	}

	//Generic pick bonus
	protected PicksPositions(): PickBonusElemGeometry {
		let spacing:number = 60;
		let width: number = Math.floor((1920 - 80 - 80) / PickBonus.MAX_COLS) - spacing;
		
		width=width+14;
		let height: number = Math.floor((1080 - 80 - 140) / PickBonus.MAX_ROWS) - spacing;
		
		height=height+18;
		return new PickBonusElemGeometry(new Size(width, height), new Rect(0, 0, width, height), new Rect(0, 0, width, height));
	}


	protected PreparePickContainer(resourceManager: IWriteOnlyResourceManager)
	{
		this.pickContainer = CreateElement("div", {classes: [this.resid.Scope(), "PickContainer"], style: {
			top: "80px",
			left: "80px",
			right: "80px",
			bottom: "140px",
			zIndex: ""+ZIndex.BonusPickContainer,
			position: "absolute",

			display: "flex",
			flexDirection: "column",
			justifyContent: "space-around",
			border: "20px solid rgb(204,159,15)",
			borderRadius: "30px",
			boxShadow: "inset 0 0 0px 1px black, inset 0 0 0px 2px black ,0px 0px 0px 1px black, 0px 0px 0px 2px black"
			// TODO
		}});

		// create rows
		this.pickRows = [];
		for (let r = 0; r < PickBonus.MAX_ROWS; r++)
		{
			let row: PickRow = new PickRow();
			row.view = CreateElement("div", {classes: ["PickRow", "PickRow-" + r], style: {
				width: "100%",
				display: "flex",
				justifyContent: "space-around",
			}});

			this.pickRows.push(row);
			this.pickContainer.appendChild(row.view);
		}
	}

	
	protected async PicksLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		//let pickGeometries: PickBonusElemGeometry[] = this.PicksPositions();
		let numPickElements: number = 50;
		let pickGeometry: PickBonusElemGeometry = this.PicksPositions();

		let p: number = 0;
		for (let r = 0; r < PickBonus.MAX_ROWS; r++)
		{
			for (let c = 0; c < PickBonus.MAX_COLS; c++, p++)
			{
				this.pickSprite = new PickSprite();

				// TODO fix sprites to run at 24fps, to remove unnecessary frames!!
				this.pickSprite.spriteCoin = resourceManager.Get<SpriteResource>(this.resid.Add("pick_coin")).sprite;
				this.pickSprite.spriteCoin.config.props.fps = 72;
				
				this.pickSprite.spriteJp1 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_blue")).sprite;
				this.pickSprite.spriteJp1.config.props.fps = 60;
				this.jpSpriteMap.set("jp1", this.pickSprite.spriteJp1);
	
				this.pickSprite.spriteJp2 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_green")).sprite;
				this.pickSprite.spriteJp2.config.props.fps = 60;
				this.jpSpriteMap.set("jp2", this.pickSprite.spriteJp2);
	
				this.pickSprite.spriteJp3 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_red")).sprite;
				this.pickSprite.spriteJp3.config.props.fps = 60;
				this.jpSpriteMap.set("jp3", this.pickSprite.spriteJp3);
	
				this.pickSprite.spriteJp4 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_white")).sprite;
				this.pickSprite.spriteJp4.config.props.fps = 60;
				this.jpSpriteMap.set("jp4", this.pickSprite.spriteJp4);


				let canvasSprite: CanvasSprite = new CanvasSprite({sprite: this.pickSprite.spriteCoin, canvasSize: pickGeometry.displaySize});
				canvasSprite.View().style.transform="scale(1.2)";
				let params: PickBonusPickElementParams = new PickBonusPickElementParams(
					p,
					this.logGroup,
					pickGeometry.displaySize, 
					pickGeometry.pickRect, 
					pickGeometry.awardRect, 
					canvasSprite,
					this.pickSprite,
					this.resid.ScopedResourceName("award"),
				);

				let pick: PickBonusElement = this.params.pickElementFactory.CreatePickElement(params);
				
				pick.AddPickCallback((index: number) => this.OnPicked(index));
				pick.AddPickBonusAwardDisplayedCallback((index: number) => this.OnAwardRevealed(index));
				pick.AddPickBonusRemainingDisplayedCallback((index: number) => this.OnRemainingRevealed(index));

				pick.View().classList.add("pickerContainer");
			
				this.picks.push(pick);

				this.pickRows[r].picks.push(pick);
				this.pickRows[r].view.appendChild(pick.View());
			}
		}
	}

	private ShowContainer(container: HTMLElement): void {
		container.style.visibility = "";
	}

	private HideContainer(container: HTMLElement): void {
		container.style.visibility = "hidden";
	}

	protected OnBonusBegin(): void {
		// waiting for start config
	}

	private OnIntroMessageBegin(): void {

		/* this.transitionView.style.visibility="visible";
		TweenLite.fromTo(this.transitionView, 1, {autoAlpha:0}, {autoAlpha:1});
	
		this.videotransition.play();

		setTimeout(()=>{
			TweenLite.to(this.transitionView, 1.5, {autoAlpha:0});
		}, 2000);

		setTimeout(()=>{
			this.videotransition.pause;
			this.videotransition.load();
		}, 4500); */

		


		this.HideContainer(this.finalMessageContainer);
		this.session.left = this.startConfig.RequiredElementsToPicks[this.session.currentPage];
		this.screenProtocol.Send(new PickBonusMessages.IntroMessage(this.session),this.screenProtocolScope);
		this.stateMachine.ChangeState(PickBonusState.PagePrepare);

	}

	private OnIntroMessageEnd(): void {
	}

	protected triggerStartSoundLoop: IInterval;
	protected introStartSound: ITimeout;
	public override TriggerAnimationStartedSprite(): void {
		let delay: number = 900;
		this.triggerStartSoundLoop = this.systemContext.TimingContext().CreateInterval("gameStartAllowedDelay", delay, () => {
			//for (let i = 0; i < 3; i++) {
			this.audio.Play(this.resid.ScopedResourceName("triggered"));
			//}
		});
		this.triggerStartSoundLoop.Start();
	}

	
	public override BackGroundTransition(): void {		
		this.audio.Play(this.resid.ScopedResourceName("intro"));
		if (this.triggerStartSoundLoop.Running()) {
			this.triggerStartSoundLoop.Restart();
			this.triggerStartSoundLoop.Stop();

		}
	}

	protected static readonly MAX_ROWS = 5;
	protected static readonly MAX_COLS = 10;
	protected static readonly MAX_PICS = PickBonus.MAX_ROWS * PickBonus.MAX_COLS;
	protected zoomFactor: number = 1;

	protected PreparePickElements() :void
	{
		let numOfPicks: number = this.startConfig.NumOFPickPerPage[this.session.currentPage];
		
		// width to height ratio when max picks are visible
		let ratio: number = PickBonus.MAX_COLS / PickBonus.MAX_ROWS;

		let rows = Math.round(Math.sqrt(numOfPicks / ratio));
		let cols = Math.ceil(numOfPicks / rows);
		rows = Math.ceil(numOfPicks / cols);

		// zoom factor
		let defaultWidth: number = Math.floor((1920 - 80 - 80) / PickBonus.MAX_COLS);
		let defaultHeight: number = Math.floor((1080 - 80 - 140) / PickBonus.MAX_ROWS);

		let width: number = Math.floor((1920 - 80 - 80) / cols);
		let height: number = Math.floor((1080 - 80 - 140) / rows);

		this.zoomFactor = Math.min(width / defaultWidth, height / defaultHeight);


		this.picksCurrentPage = [];

		let r = 0;
		for (; r < rows; r++)
		{
			// show row
			this.pickRows[r].view.style.display = "flex";


			let c = 0;
			for (; c < cols && this.picksCurrentPage.length < numOfPicks; c++)
			{
				// show pick
				this.pickRows[r].picks[c].SetIndex(this.picksCurrentPage.length);
				this.pickRows[r].picks[c].View().style.display = "block";
				this.pickRows[r].picks[c].View().style.transform = "scale(" + this.zoomFactor + ")";
				this.pickRows[r].picks[c].View().style.zIndex = ""; 

				this.picksCurrentPage.push(this.pickRows[r].picks[c]);
			}

			// hide remaining pick in row
			for (; c < PickBonus.MAX_COLS; c++)
			{
				// hide column element
				this.pickRows[r].picks[c].View().style.display = "none";
			}
		}

		// hide remaining rows
		for (; r < PickBonus.MAX_ROWS; r++)
		{
			// hide row
			this.pickRows[r].view.style.display = "none";
		}
	}

	protected OnPagePrepareBegin(): void {
	
		//this.HideAllContainers();
		this.ShowContainer(this.pickContainer);
		this.PageReset();
		//this.ResetLevelMessage();
		//this.SetStyleForLevelMessage();

		this.session.left = this.startConfig.RequiredElementsToPicks[this.session.currentPage];
		let currentPage = this.session.currentPage;

		this.screenProtocol.Send(new PickBonusMessages.PickMessage(this.session),this.screenProtocolScope);


		this.PreparePickElements();
		
		this.levelInfoMessagesMap.get(currentPage).Show();
		
		
		//this.transition.Start();
		for (let i = 0; i < this.picksCurrentPage.length; i++) 
		{
			this.picksCurrentPage[i].Start();
		}
		this.stateMachine.ChangeState(PickBonusState.LevelMessage);
	}

	protected OnLevelMessageBegin():void
	{
		if(this.session.currentPage != 0)
		{
			this.ShowVideoTransition();
		}
		//this.ShowVideoTransition();

		this.robotPlay.BonusConfirm("Level-" + this.session.currentPage + "-Message");
	
		this.ShowContainer(this.introMessageContainer);
	}

	public ShowVideoTransition():void
	{
		let videotransition: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add("PickBonus").Add("Transition"));
		TweenLite.set(videotransition.View(), {autoAlpha: 1, display: ""});
		videotransition.Play(this.resid);
	
		this.audio.Play(this.resid.ScopedResourceName("transitionLight"));
		
		// play audio with little delay
		setTimeout(() => 
		{
			this.audio.Play(this.resid.ScopedResourceName("transition"));
			if (this.session.currentPage == 0)
			{
				this.audio.Play(this.resid.ScopedResourceName("diamond-pot"));
			}
		}, 300);

		setTimeout(()=>
		{
			TweenLite.to(videotransition.View(), 0.5, {autoAlpha:0,display:"none",onComplete: () => 
			TweenLite.to(videotransition.View(), 0.5, {autoAlpha:1,display:"none"})
			});
		}, 1500);

		setTimeout(()=>{
			videotransition.StopAndReset(this.resid);
		}, 3000);

		
	}

	public NextBonusEnd()
	{
		
	}

	protected OnLevelMessageEnd():void
	{
		//play sound when you finish 

		//this.HideContainer(this.introMessageContainer);
		//this.stateMachine.ChangeState(PickBonusState.Pick);
		
		this.robotPlay.BonusConfirmAccepted();
	}

	protected OnPickBegin():void
	{
		
		
		this.awardReveled = false;
		this.winRect = null;

		this.robotPlay.BonusPick(this.session.currentPage, this.startConfig.NumOFPickPerPage[this.session.currentPage]);
	}

	protected pickedZIndex: number = ZIndex.BonusPickContainer;
	public OnPicked(index: number): void
	{
		if (this.stateMachine.State() == PickBonusState.Pick)
		{
			
			// Log.Debug(this.logGroup, "Picked index " + index);

			// TODO check state, check index bounds
			this.pickedIndex = index;
			this.session.left--;
			// protocol.Send("SelectBonusElement",{selectedElement: index});
			this.pickedZIndex ++;

			this.picksCurrentPage[index].BringToFront();
			this.picksCurrentPage[index].isPicked = true;
			SetStyles(this.picksCurrentPage[index].View(),
			{
				transform: "scale("+(this.zoomFactor * 1.2) +") ",
				zIndex: ""+this.pickedZIndex,
			});

			this.screenProtocol.Send(new PickBonusMessages.PickMessage(this.session),this.screenProtocolScope);

			this.audio.Play(this.resid.ScopedResourceName("pick"));

			this.stateMachine.ChangeState(PickBonusState.RevealPicked);

			this.robotPlay.BonusPickAccepted(index);
		}
		else {
			Log.Error(this.logGroup, "Wrong state to pick award! Required: " + PickBonusState[PickBonusState.Pick] + ", current: " + PickBonusState[this.stateMachine.State()]);
		}
	}

	//protected freeSpotForJackpot:number = 0;
	
	protected OnAwardRevealed(index: number): void {
		if (this.stateMachine.State() == PickBonusState.RevealPicked)
		{
			// Log.Debug(this.logGroup, "Revealed award");

			if(this.session.left >=  0)
			{
				if(this.pickedAward.PickType == 1)
				{
					this.session.totalWin += (this.pickedAward as PickBonusCashReward).Reward.InCents;
				}
				else if (this.pickedAward.PickType == 2)
				{
					this.session.totalWin += (this.pickedAward as PickBonusJackpotReward).WinAmount.InCents;
				}
				
				this.awardReveled = true;
				this.picksCurrentPage[index].ZoomSelected();
				this.TryDisplayCommet();
			}
			
		}
		else {
			Log.Error(this.logGroup, "Wrong state to reveal picked award! Required: " + PickBonusState[PickBonusState.RevealPicked] + ", current: " + PickBonusState[this.stateMachine.State()]);
		}
	}

	private NextPick():void
	{
		if (this.stateMachine.State() == PickBonusState.RevealPicked)
		{
			if(this.session.left == 0)
			{
				setTimeout(() => {
					// Log.Debug(this.logGroup, "Revealing remaining rewards");
					this.remaining_animEnded = true;
					this.TryRevealRemaining();
				}, 1500);

				this.stateMachine.ChangeState(PickBonusState.RevealRemaining);	

			}
			
			else
			{
				this.stateMachine.ChangeState(PickBonusState.Pick);
			}
			
			this.revealed++;
		}
	}

	protected TryRevealRemaining(): void {
		
			if (this.remaining_animEnded && this.remaining_awardsSet) {
				this.nextToBeRevealed= 0;
				this.audio.Play(this.resid.ScopedResourceName("remaining"));

				this.time = window.setInterval(()=>
				{
					this.RevealNext();

				},20);

				// Log.Debug(this.logGroup, "Revealing remaining"); 
			}
			else {
			Log.Error(this.logGroup, "Wrong state to RevealRemaining ! Required: " + this.remaining_animEnded + ", and  " +this.remaining_awardsSet);
		}

	}

	protected RevealNext():void
	{
		while(this.nextToBeRevealed < this.picksCurrentPage.length && this.picksCurrentPage[this.nextToBeRevealed].isPicked == true )
		{
			this.nextToBeRevealed++;
		}

		if(this.nextToBeRevealed == this.picksCurrentPage.length)
		{
			clearInterval(this.time);
		}
		else
		{
			this.picksCurrentPage[this.nextToBeRevealed].PushToBack();
			this.picksCurrentPage[this.nextToBeRevealed].RevealRemaining();
			this.nextToBeRevealed++;
		}
	}

	protected OnRemainingRevealed(index: number): void {
		if (this.stateMachine.State() == PickBonusState.RevealRemaining) {
			// Log.Debug(this.logGroup, "Revealed remaining, index " + index);
			this.session.left = this.startConfig.RequiredElementsToPicks[this.session.currentPage];
			let currentPage = this.session.currentPage;
			console.log("pickbonus page:",currentPage);
			this.revealed++;
			let jpward = this.pickedAward as PickBonusJackpotReward;
			if (this.revealed == this.picksCurrentPage.length) 
			{
				//console.log("pickbonus:",this.revealed);
			
				this.audio.Stop(this.resid.ScopedResourceName("remaining"));
				if(this.nextPage == true)
				{
					//console.log("pickbonus:",index);
					this.session.currentPage ++;
					setTimeout(() => this.stateMachine.ChangeState(PickBonusState.PagePrepare), 1500);
				}
				else
				{
					//put my code 
					if(currentPage==3 && jpward.JackpotCount == 4 && jpward.JackpotName=="jp4" )
					 {
						setTimeout(() => this.stateMachine.ChangeState(PickBonusState.FinalMessage), 1500);
					 }
					


					else
					 {
						setTimeout(() => this.stateMachine.ChangeState(PickBonusState.FinalMessage), 1500);
					 }
				}
				
			}
		}
		else 
			{
				Log.Error(this.logGroup, "Wrong state to reveal remaining! Required: " + PickBonusState[PickBonusState.RevealRemaining] + ", current: " + PickBonusState[this.stateMachine.State()]);
			}
	}

	private OnFinalMessageBegin(): void {
		//setTimeout(() =>
		//{
		
		this.ShowVideoTransition();


		this.PanelRequired(false);

		//this.HideAllContainers();

		//this.finalMessageContainer.querySelector(".totalWin").innerHTML = "";
		//let translatedMessage2 = this.translator.Translate(() => this.translator.t.winbonus(service.moneyFormatter.FormatCredit(this.session.totalWin)));
		
		this.finalMessage.Update();
		
		console.log("Final"+this.session.currentPage);

		this.ShowContainer(this.finalMessageContainer);

		//this.transition.Start();

		// TODO MIGHT PLAY AFTER FINAL MESSAGE CONFIRMED!
		this.pickwin1SoundTimer.Start();
		this.pickbonuswinSoundTimer.Start();

		this.robotPlay.BonusConfirm("FinalMessage");
	//},3600);
	}

	private OnFinalMessageEnd(): void {
		
			

		this.audio.Stop(this.resid.ScopedResourceName("background"));

		this.pickwin1SoundTimer.Stop();
		this.audio.Stop(this.resid.ScopedResourceName("pickwin1"));


		//this.audio.Play(this.resid.ScopedResourceName("backgroundend"));
		this.OnBonusFinished();
		//this.View().querySelector(".finalMessage").innerHTML = ""
		//this.transition.Start();
		this.robotPlay.BonusConfirmAccepted();
	}


	public GetBonusWin():number
	{
		if (this.session.totalWin != null)
			return this.session.totalWin;
		else 
			return 0;
	}


	/**
	 *	External messages
	**/

	// protected bonusStartConfig: IBonusStartConfig = null;
	// public OnBonusStartConfig(config: BonusStartConfigMessage): void
	// {
	// 	this.bonusStartConfig = config.StartConfig;
	// }

	// there are elements available to pick
	public OnBonusPickElement(pickElement: BonusPickElement): void
	{
		// Log.Debug(this.logGroup, "OnBonusPickElement(pickElement: " + JSON.stringify(pickElement) + ")");
	}

	// reveal picked element
	public OnBonusPickReveal(pickReveal: BonusPickReveal): void{
		// Log.Debug(this.logGroup, "OnBonusRevealPick(pickReveal: " + JSON.stringify(pickReveal) + ")");

		let pick: PickBonusRevealValue = pickReveal as PickBonusRevealValue;
		//// Log.Debug(this.logGroup, "Picked award: " + pick.RevealedValue.Reward);
		this.pickedAward = pick.RevealedValue;
		

		if((pickReveal.RevealedValue as PickBonusReward).PickType == 1)
		{
			this.session.win = (pick.RevealedValue as PickBonusCashReward).Reward.InCents;
		}
		else if((pickReveal.RevealedValue as PickBonusReward).PickType == 2)
		{
			this.session.win = (pick.RevealedValue as PickBonusJackpotReward).WinAmount.InCents;
		}
		

		this.picksCurrentPage[this.pickedIndex].SetAward(this.pickedAward);
		this.screenProtocol.Send(new PickBonusMessages.AwardMessage(null,this.pickedAward),this.screenProtocolScope)

		this.picked_awardSet = true;

		// maybe message is late, try to reveal now
		//this.TryRevealAward();

	}

	// reveal remaining elements
	public OnBonusRevealRemaining(revealRemaining: BonusRevealRemaining): void{
		let pcRemaining: PickBonusRevealRemaining = revealRemaining as PickBonusRevealRemaining;
		// Log.Debug(this.logGroup, "OnBonusRevealRemaining(revealRemaining: " + JSON.stringify(revealRemaining) + ")");


		for (let i = 0; i < pcRemaining.Remaining.Remaining.length; i++) {
			if(this.picksCurrentPage[i].isPicked == false)
			{
				this.picksCurrentPage[i].SetRemaining(pcRemaining.Remaining.Remaining[i]);
			}
			
		}

		this.nextPage = pcRemaining.Remaining.NextPage;

		this.remaining_awardsSet = true;

		// maybe message is late, try to reveal now

		this.TryRevealRemaining();
	}

	// another run result
	public OnBonusRunResult(runResult: RunResultMessage): void{

	}

	// total result (currently sent when bonus finishes)
	public OnBonusTotalResult(totalResult: BonusTotalResult): void{
		// Log.Debug(this.logGroup, "OnBonusTotalResult(totalResult: " + JSON.stringify(totalResult) + ")");
		
	}

	// signal, that bonus has finished
	public OnBonusFinish(bonusFinish: BonusFinish): void{
		// Log.Debug(this.logGroup, "OnBonusFinish(bonusFinish: " + JSON.stringify(bonusFinish) + ")");

		this.audio.Stop(this.resid.ScopedResourceName("background"));
	}

	/*
	*---------------------------------------
	*/

	public Confirm():void
	{
		/*
		if (this.stateMachine.State() == PickBonusState.IntroMessage) {

		}
		else 
		*/
		if (this.stateMachine.State() == PickBonusState.LevelMessage) {
			// Log.Debug(this.logGroup, "Start message confirmed");
			//this.stateMachine.ChangeState(PickBonusState.PagePrepare);
			this.stateMachine.ChangeState(PickBonusState.Pick);
			this.HideContainer(this.introMessageContainer);
			this.levelInfoMessagesMap.get(this.session.currentPage).Hide();
			//this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
			//this.audio.Stop(this.resid.ScopedResourceName("chances"));
		}
		else if (this.stateMachine.State() == PickBonusState.FinalMessage) {
			// Log.Debug(this.logGroup, "Final message confirmed");
			this.stateMachine.ChangeState(PickBonusState.Idle);
			this.audio.Stop(this.resid.ScopedResourceName("pickwin1"));
		}
		else {
			Log.Error(this.logGroup, "Can't confirm any message, current state: " + PickBonusState[this.stateMachine.State()]);
		}
	}


	public Spin(): void
	{

		switch (this.stateMachine.State()) {

			case PickBonusState.IntroMessage:
			case PickBonusState.FinalMessage:
			case PickBonusState.LevelMessage:
				 this.Confirm();
			break;
		}

	}

	public Update(): void
	{
		for (let i = 0; i < this.picksCurrentPage.length; i++) {
			this.picksCurrentPage[i].Update();
		}



		this.cometMap.forEach((commet:CanvasSprite)=>{
			commet.Update();
		});
	}

	public Start(): void {

		this.Reset();
		this.Show();
		this.PanelRequired(false);
		this.stateMachine.ChangeState(PickBonusState.IntroMessage);
		//this.screenProtocol.Send(new PickBonusMessages.)

		this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
	}

	public Reset():void
	{
		this.PageReset();
		//this.winContainer.innerHTML ="";
		
	
		this.session.Reset();
		this.HideContainer(this.finalMessageContainer);

		/* this.pickJackpots.forEach((jackpot:PickJackpot)=>
		{
			for(let i = 0; i < jackpot.WinContainer.length; i++)
			{
				jackpot.WinContainer[i].style.backgroundImage = "none";
			}
			
		}); */
	}

	private PageReset():void
	{
		this.picked_awardSet = false;
		this.picked_animEnded = false;

		this.remaining_animEnded = false;
		this.remaining_awardsSet = false;

		this.pickedIndex = -1;
		this.revealed = 0;
		this.nextToBeRevealed = 0;
		this.pickedZIndex = ZIndex.BonusPickContainer;

		for(let i = 0; i < this.picks.length; i++)
		{
			this.picks[i].Reset();
			SetStyles(this.picks[i].View(),
			{
				transform:"scale(1)",

			});
		}

		
	}

	public View(): HTMLElement {
		return this.view;
	}

	public Hide():void
	{
		this.view.style.display = "none";
		console.log("Hide Pick bonus");
	}

	public Show():void
	{
		this.view.style.display = "block";
		console.log("Show pick bonus");
	}

	protected startConfig: IPickBonusStartConfig;
	public Prepare(startConfig: IBonusStartConfig): void
	{
		this.startConfig = startConfig as IPickBonusStartConfig;
		this.screenProtocol.Send(new PickBonusMessages.PrepareMessage(this.session, this.startConfig), this.screenProtocolScope);
	}

	public HistoryView(actionIndex:number, gameState: SimpleSlotGameState): HTMLElement
	{
		let action: IPickBonusAction = gameState.Actions[actionIndex] as unknown as IPickBonusAction;
		let currentPage: number = action.CurrentPage;
		

		let bonusView: HTMLElement = CreateElement("div",{classes:["bonusView", "PickBonusHistory"],
			style:
			{
				width:"100%",
				height:"100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}
		});

		let gameView: HTMLElement = CreateElement("div", {classes:["gameBackground"], parentToAppend: bonusView, 
			style:
			{
				width:"1000px",
				height:"800px",
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				backgroundPosition: "center",
				display: "flex",
				flexDirection:"column",
				justifyContent: "space-around",
				alignItems: "center",
				backgroundImage: this.gameBackground.CssBackground(),
			}
		});

		let pickedELements: HTMLElement = CreateElement("div", {classes:["pickedELements"], parentToAppend: gameView, innerHTML: "",
			style:
			{
				height:"200px",
				width:"100%",
				display:"flex",
				flexDirection:"row",
			}
		});
		
		for(let i = actionIndex; (gameState.Actions[i] as unknown as IPickBonusAction).CurrentPage == currentPage; i--)
		{
			let a = gameState.Actions[i] as unknown as IPickBonusAction;
			if(a.AwardType == "Jackpot")
			{
				let jpName = a.JackpotName;
				
				let jPElement: HTMLElement = CreateElement("div", {classes:["jPElement"], parentToPrepend: pickedELements,
					style:
					{
						width:"20%",
						height:"100%",
					}
				});

				let jpImg : MyCanvas  = new MyCanvas(new Size(200,200));
				let jpSprite:Sprite = this.jpSpriteMap.get(jpName);
				jpImg.DrawImage(jpSprite.shared.decodedFrames[jpSprite.shared.decodedFrames.length-1],jpSprite.GenericRectangle,jpImg.rect);

				jPElement.appendChild(jpImg.view);
			}
			else
			{
				let cashWin: number = a.WinAmount.InCents;

				let cashElement: HTMLElement = CreateElement("div", {classes:["cashElement"], parentToPrepend: pickedELements,
					style:
					{
						width:"20%",
						height:"100%",
						display:"flex",
						justifyContent:"center",
						alignItems:"center",
					}
				});

				let cashImg : MyCanvas  = new MyCanvas(new Size(200,200));
				cashImg.DrawImage(this.pickSprite.spriteCoin.shared.decodedFrames[this.pickSprite.spriteCoin.shared.decodedFrames.length-1],this.pickSprite.spriteCoin.GenericRectangle,cashImg.rect);

				cashElement.appendChild(cashImg.view);

				let cashReward: HTMLElement = CreateElement("div", {classes:["cashReward"], parentToAppend: cashElement ,innerHTML:""+ service.moneyFormatter.FormatCurrency(a.WinAmount.InCents),
					style:
					{
						position:"absolute",
						display:"flex",
						justifyContent:"center",
						alignItems:"center",
						fontSize:"30px",
						color:"white",
						fontFamily:"NotoSansDisplay-ExtraBold",
						textShadow: "0px 0px 5px black, 0px 0px 10px black, 0px 0px 15px black, 0px 0px 40px black",
					}
				});
			}
		}

		let jpCountWin: HTMLElement = CreateElement("div", {classes:["jpCountWin"], parentToAppend: gameView,
			style:
			{
				width:"80%",
				height:"300px",
				display:"flex",
				alignItems:"center",
			}
		});

		let jpCountMap: Map<string, HTMLElement> = new Map<string,HTMLElement>();
		for(let i = 0; i < this.params.bonusConfiguration.RequiredJpToWin.length; i++)
		{
			let jpName = this.params.bonusConfiguration.RequiredJpToWin[i].Name;
			let oneJpCount: HTMLElement = CreateElement("div", {classes:["oneJpCount", ""+jpName], parentToAppend:jpCountWin,
				style:
				{
					width:"25%",
					height:"80%",
					display:"flex",
					flexDirection:"column",
					justifyContent:"center",
				}
			});

			let jpImg: HTMLElement = CreateElement("div", {classes:["jpImg"], parentToAppend:oneJpCount,
				style:
				{
					width:"100%",
					height:"50%",
					display:"flex",
					justifyContent:"center",
				}
			})

			let jpImgSprite : MyCanvas  = new MyCanvas(new Size(100,200));
			let jpSprite:Sprite = this.jpSpriteMap.get(jpName);
			jpImgSprite.DrawImage(jpSprite.shared.decodedFrames[jpSprite.shared.decodedFrames.length-1],jpSprite.GenericRectangle,jpImgSprite.rect);

			jpImg.appendChild(jpImgSprite.view);

			let jpCountBox: HTMLElement = CreateElement("div", {classes:["jpCountBox"], parentToAppend:oneJpCount,
				style:
				{
					width:"100%",
					height:"50%",
					display:"flex",
					flexDirection:"row",
					fontSize:"30px",
					color:"white",
				}
			})
			let jpCount: HTMLElement = CreateElement("div", {classes:["jpCount", ""+i, ""+this.params.bonusConfiguration.RequiredJpToWin[i].Name], parentToAppend:jpCountBox, innerHTML:""+0,
				style:
				{
					height:"100%",
					width:"50%",
					display:"flex",
					justifyContent:"flex-end",
					fontSize:"50px",
					
				}
			});

			let jpCountRequired: HTMLElement = CreateElement("div", {classes:["jpCountRequired", ""+i], parentToAppend:jpCountBox, innerHTML:"/" + this.params.bonusConfiguration.RequiredJpToWin[i].RequiredToHit,
				style:
				{
					height:"100%",
					width:"50%",
					display:"flex",
					justifyContent:"flex-start",
					fontSize:"50px",
					
				}
			});

			jpCountMap.set(this.params.bonusConfiguration.RequiredJpToWin[i].Name, jpCount);

		}
		
		//this.HistoryUpdateJpCount(jpCountMap, action);
		this.HistoryUpdateJpCount(gameState,jpCountMap, actionIndex);
		
		return bonusView;
	}

	protected HistoryUpdateJpCount(gameState: SimpleSlotGameState,jpCountMap: Map<string, HTMLElement>, actionIndex: number)
	{
		jpCountMap.forEach((jpCount:HTMLElement, jpName: string) =>
		{
			for(let i = 1; i <= actionIndex; i++)
			{
				if((gameState.Actions[i] as unknown as IPickBonusAction).JackpotName == jpName)
				{
					jpCount.innerHTML = ""+ (gameState.Actions[i] as unknown as IPickBonusAction).JackpotCount;
				}
			}
		});
	}


	public HistoryStats2(actionIndex:number, gameState: SimpleSlotGameState): ActionStats
	{
		return {
			Bonus : null,
			Action : null,
			Stats : []
		}
	}

	public PixiCanvasCrash(): void {};
	//public DestroyPixi() {};
	public ReCreatePixiReels(){}
	public GameSelected() {}
	public GameExit() {}
}

// class PickBonus_2Screen extends PickBonus
// {
// 	public transition:HTMLElement=null;
// 	public TitleDragonLink:HTMLElement=null;

// 	public DragonLinkSprite:CanvasSprite = null;
	
// 	constructor(gameName: string, params: PickBonusParams)
// 	{
// 		super(gameName,params);
// 	}

// 	public AudioPrepare(resourceManager:ResourceManager)
// 	{
// 		super.AudioPrepare(resourceManager);

// 		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonVoice/backgroundDrangonJackpot" + Settings.audioFormat, this.resid.ScopedResourceName("Diamondwin")));
// 		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonVoice/firetransition" + Settings.audioFormat, this.resid.ScopedResourceName("firetransition")));
// 		//Add new Voice for Dragon Jackpot
// 		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonVoice/DragonJackpot" + Settings.audioFormat, this.resid.ScopedResourceName("DiamondFamale")));
// 		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonVoice/GrandJackpot" + Settings.audioFormat, this.resid.ScopedResourceName("RubyFamale")));
// 		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonVoice/Minor" + Settings.audioFormat, this.resid.ScopedResourceName("EmeraldFamale")));
// 		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonVoice/Mini" + Settings.audioFormat, this.resid.ScopedResourceName("SapphireFamale")));
// 		//Load Voice Diamond POT
// 		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "DragonVoice/DragonLink" + Settings.audioFormat, this.resid.ScopedResourceName("diamond-pot")));
	
// 	}

// 	protected SpriteLoaded(resourceManager:ResourceManager):void
// 	{
// 		this.pickCometSprite = new CanvasSprite(resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("Commet")).sprite.Copy(), null, true, CanvasSpriteSizing.Stretch);
// 		this.blueCommetSprite = new CanvasSprite(resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("BlueCommet")).sprite.Copy(), null,true,CanvasSpriteSizing.Stretch);
// 		this.redCommetSprite = new CanvasSprite(resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("RedCommet")).sprite.Copy(), null,true,CanvasSpriteSizing.Stretch);
// 		this.greenCommetSprite = new CanvasSprite(resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("GreenCommet")).sprite.Copy(), null,true,CanvasSpriteSizing.Stretch);
// 		this.whiteCommetSprite = new CanvasSprite(resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("PickBonus").Add("WhiteCommet")).sprite.Copy(), null,true,CanvasSpriteSizing.Stretch);
		
// 		// this.pickCometSprite.View().style.zIndex = ""+ ZIndex.BonusPickComet; //"4";
// 		// this.blueCommetSprite.View().style.zIndex = ""+ ZIndex.Jp1Comet;//"4";
// 		// this.redCommetSprite.View().style.zIndex = ""+ ZIndex.Jp2Comet;//"4";
// 		// this.greenCommetSprite.View().style.zIndex = ""+ ZIndex.Jp3Comet;//"4";
// 		// this.whiteCommetSprite.View().style.zIndex = ""+ ZIndex.Jp4Comet;//"4";

// 		this.cometMap.set("pickCommet", this.pickCometSprite);
// 		//CHANGE BLUE PER GREEN
// 		this.cometMap.set("jp1", this.greenCommetSprite);

// 		//Red comet
// 		this.cometMap.set("jp3", this.redCommetSprite);

// 		//Green comet 
// 		//CHANGE GREEN PER BLUE
// 		this.cometMap.set("jp2", this.blueCommetSprite);

// 		//White commet
// 		this.cometMap.set("jp4", this.whiteCommetSprite);


// 		this.cometMap.forEach((commet:CanvasSprite)=>{
// 			commet.View().style.position = "absolute";
// 			this.view.appendChild(commet.View());
// 			//this.cometSize = commet.Size();

// 			commet.AddOnCompleteCallback(()=> this.CometComplete())
// 			commet.Hide();
// 		});

// 		this.transition=document.createElement("div");
// 		this.transition.style.width="1920px";
// 		this.transition.style.height="2160px";
// 		this.transition.style.backgroundImage=resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["transition"])).CssBackground();
// 		this.transition.style.display="flex";
// 		this.transition.style.position="absolute";
// 		this.transition.style.bottom="0px";
// 		this.transition.style.zIndex=ZIndex.BonusTransition.toString();
// 		this.transition.style.alignContent="center";
// 		this.transition.style.justifyContent="center";

// 	/* 	this.TitleDragonLink=document.createElement("div");
// 		this.TitleDragonLink.style.width="1800px";
// 		this.TitleDragonLink.style.height="260px";
// 		this.TitleDragonLink.style.backgroundImage=resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["TitleDragonLink"])).CssBackground();
// 		this.TitleDragonLink.style.display="flex";
// 		//this.TitleDragonLink.style.position="absolute";
// 		//this.TitleDragonLink.style.top="0px";
// 		this.TitleDragonLink.style.zIndex=ZIndex.FreeGameIntroText.toString();
		
// 		this.TitleDragonLink.style.backgroundRepeat="no-repeat";
// 		this.TitleDragonLink.style.backgroundPosition="center";
// 		this.transition.appendChild(this.TitleDragonLink);
// 	 */
// 		this.DragonLinkSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("Dragon_link_sprite").Add("Title")).sprite, canvasSize: new Size(1920, 400)});
// 		this.DragonLinkSprite.View().style.position="absolute";
// 		this.DragonLinkSprite.View().style.top="416px";	
// 		this.transition.appendChild(this.DragonLinkSprite.View());
// 		this.DragonLinkSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("firetransition")));
		
	
// 		this.view.appendChild(this.transition);

				
		
// 	}

// 	protected PicksLoaded(resourceManager: IReadOnlyResourceManager): void {

// 		//let pickGeometries: PickBonusElemGeometry[] = this.PicksPositions();
// 		let numPickElements: number = 50;
// 		let pickGeometry: PickBonusElemGeometry = this.PicksPositions();

// 		let p: number = 0;
// 		for (let r = 0; r < PickBonus.MAX_ROWS; r++)
// 		{
// 			for (let c = 0; c < PickBonus.MAX_COLS; c++, p++)
// 			{
// 				this.pickSprite = new PickSprite();

// 				// TODO fix sprites to run at 24fps, to remove unnecessary frames!!
// 				this.pickSprite.spriteCoin = resourceManager.Get<SpriteResource>(this.resid.Add("pick_coin")).sprite;
// 				this.pickSprite.spriteCoin.config.props.fps = 72;
				
// 				//CHANGE BLUE PER GREEN
// 				this.pickSprite.spriteJp1 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_green")).sprite;
// 				this.pickSprite.spriteJp1.config.props.fps = 60;
// 				this.jpSpriteMap.set("jp1", this.pickSprite.spriteJp1);
// 				//CHANGE GREEN PER BLUE
// 				this.pickSprite.spriteJp2 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_blue")).sprite;
// 				this.pickSprite.spriteJp2.config.props.fps = 60;
// 				this.jpSpriteMap.set("jp2", this.pickSprite.spriteJp2);
	
// 				this.pickSprite.spriteJp3 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_red")).sprite;
// 				this.pickSprite.spriteJp3.config.props.fps = 60;
// 				this.jpSpriteMap.set("jp3", this.pickSprite.spriteJp3);
	
// 				this.pickSprite.spriteJp4 = resourceManager.Get<SpriteResource>(this.resid.Add("pick_white")).sprite;
// 				this.pickSprite.spriteJp4.config.props.fps = 60;
// 				this.jpSpriteMap.set("jp4", this.pickSprite.spriteJp4);


// 				let canvasSprite: CanvasSprite = new CanvasSprite(this.pickSprite.spriteCoin, pickGeometry.displaySize);
// 				canvasSprite.View().style.transform="scale(1.2)";
// 				let params: PickBonusPickElementParams = new PickBonusPickElementParams(
// 					p,
// 					this.logGroup,
// 					pickGeometry.displaySize, 
// 					pickGeometry.pickRect, 
// 					pickGeometry.awardRect, 
// 					canvasSprite,
// 					this.pickSprite,
// 					this.moneyFormatter,
// 					this.resid.ScopedResourceName("award"),
// 				);

// 				let pick: PickBonusElement = this.params.pickElementFactory.CreatePickElement(params);
				
// 				pick.AddPickCallback((index: number) => this.OnPicked(index));
// 				pick.AddPickBonusAwardDisplayedCallback((index: number) => this.OnAwardRevealed(index));
// 				pick.AddPickBonusRemainingDisplayedCallback((index: number) => this.OnRemainingRevealed(index));

// 				pick.View().classList.add("pickerContainer");
			
// 				this.picks.push(pick);

// 				this.pickRows[r].picks.push(pick);
// 				this.pickRows[r].view.appendChild(pick.View());
// 			}
// 		}
// 	}

// 	protected ShowVideoTransition():void
// 	{
// 		//this.transition.style.display="flex";
// 		/* let videotransition: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add("PickBonus").Add("Transition"));
// 		*/
// 		TweenLite.set(this.transition, {autoAlpha: 1, display: ""});
// 		this.DragonLinkSprite.Start(false);
		
	
	
// 		// play audio with little delay
// 		setTimeout(() => 
// 		{
// 			//this.audio.Play(this.resid.ScopedResourceName("transition"));
// 			if (this.session.currentPage == 0)
// 			{
// 				this.audio.Play(this.resid.ScopedResourceName("diamond-pot"));
// 			}
// 		}, 300);

// 		setTimeout(()=>
// 		{
			
// 		 	TweenLite.to(this.transition, 0.5, {autoAlpha:0,display:"none",onComplete: () => 
// 		 	TweenLite.to(this.transition, 0.5, {autoAlpha:1,display:"none"})
			
		
// 		});
		
		
// 		}, 1500); 
		
 	
// 	}

// 	protected PrepareVideos(resourceManager: ResourceManager): void
// 	{
// 		//resourceManager.AddGlobal(new VideoResource(this.params.commonBonusResourcesBasePath + "video/transition.mp4", ResourceIdentifier.Global.Add("PickBonus").Add("Transition"), LogGroup.Global.Add("PickBonus").Add("Transition")));

// 		//DONT CREATE VIDEO TRANSITION IN 2Screen DONT USE 
// 	/* 	resourceManager.AddGlobal(new VideoResource2({
// 			resid: ResourceIdentifier.Global.Add("PickBonus").Add("Transition"),
// 			logGroup: LogGroup.Global.Add("PickBonus").Add("Transition"),
// 			src: this.params.commonBonusResourcesBasePath + "video/transition.mp4",
// 			unloadOnEnd: true
// 		})); */

// 		//resourceManager.AddGlobal(new VideoResource("resources/multigame/slot/common/resources/PickBonus/video/white.mp4", ResourceIdentifier.Global.Add("jp4"), LogGroup.Global.Add("JP4Video")));

// 		resourceManager.AddGlobal(new VideoResource2({
// 			resid: ResourceIdentifier.Global.Add("jp4"),
// 			logGroup: LogGroup.Global.Add("JP4Video"),
// 			src: "resources/multigame/slot/common/resources/PickBonus/video/white.mp4",
// 			unloadOnEnd: true
// 		}));

// 		//resourceManager.AddGlobal(new VideoResource("resources/multigame/slot/common/resources/PickBonus/video/red.mp4", ResourceIdentifier.Global.Add("jp3"), LogGroup.Global.Add("JP3Video")));

// 		resourceManager.AddGlobal(new VideoResource2({
// 			resid: ResourceIdentifier.Global.Add("jp3"),
// 			logGroup: LogGroup.Global.Add("JP3Video"),
// 			src: "resources/multigame/slot/common/resources/PickBonus/video/red.mp4",
// 			unloadOnEnd: true
// 		}));
		
// 		//resourceManager.AddGlobal(new VideoResource("resources/multigame/slot/common/resources/PickBonus/video/green.mp4", ResourceIdentifier.Global.Add("jp2"), LogGroup.Global.Add("JP2Video")));

// 		resourceManager.AddGlobal(new VideoResource2({
// 			resid: ResourceIdentifier.Global.Add("jp2"),
// 			logGroup: LogGroup.Global.Add("JP2Video"),
// 			src: "resources/multigame/slot/common/resources/PickBonus/video/blue.mp4",
// 			unloadOnEnd: true
// 		}));

// 		//resourceManager.AddGlobal(new VideoResource("resources/multigame/slot/common/resources/PickBonus/video/blue.mp4", ResourceIdentifier.Global.Add("jp1"), LogGroup.Global.Add("JP1Video")));

// 		resourceManager.AddGlobal(new VideoResource2({
// 			resid: ResourceIdentifier.Global.Add("jp1"),
// 			logGroup: LogGroup.Global.Add("JP1Video"),
// 			src: "resources/multigame/slot/common/resources/PickBonus/video/green.mp4",
// 			unloadOnEnd: true
// 		}));
// 	}

// 	protected VideosLoaded(resourceManager: IReadOnlyResourceManager): void
// 	{
// 		//dont Create video resource because dont use in 2Screen
// 		/* // make sure transition covers everything
// 		let transition: MyVideo = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("PickBonus").Add("Transition")).video;
// 		SetStyles(transition.View(), {position: "absolute", top: "0px", left: "0px", zIndex: "" + ZIndex.BonusTransition});
// 		this.systemContext.SharedVideoContext().AddVideo(transition);
//  */
// 		// make sure jackpot videos loop
// 		let jp4 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp4")).video;
// 		//jp4.video.loop = true;
// 		SetStyles(jp4.View(), {position: "absolute", top: "0px", left: "0px"});
// 		this.systemContext.SharedVideoContext().AddVideo(jp4);

// 		let jp3 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp3")).video;
// 		//jp3.video.loop = true;
// 		SetStyles(jp3.View(), {position: "absolute", top: "0px", left: "0px"});
// 		this.systemContext.SharedVideoContext().AddVideo(jp3);

// 		let jp2 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp2")).video;
// 		//jp2.video.loop = true;
// 		SetStyles(jp2.View(), {position: "absolute", top: "0px", left: "0px"});
// 		this.systemContext.SharedVideoContext().AddVideo(jp2);

// 		let jp1 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp1")).video;
// 		//jp1.video.loop = true;
// 		SetStyles(jp1.View(), {position: "absolute", top: "0px", left: "0px"});
// 		this.systemContext.SharedVideoContext().AddVideo(jp1);
// 	}
	
// 	protected CommetJP(message:PickBonusMessages.CommetJp)
// 	{
// 		let srcRect = TranslateScreen2To1(message.srcRect);
// 		let destRect = TranslateScreen2To1(message.destRect);

// 		this.StartCommet(srcRect.Center(), destRect.Center(), CommetReason.JpWin);
// 	}

// 	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>
// 	{
		
// 		super.PrepareResources(resourceManager);
// 		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "transition.png", this.resid.ScopedResourceName(["transition"])));
		
// 		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "Dragon_link_sprite", ResourceIdentifier.Global.Add("Dragon_link_sprite").Add("Title"), true, LogGroup.Global.Add("Dragon_link_sprite").Add("Title"), true))

// 	}
// 	public Update()
// 	{
// 		super.Update();
// 		this.DragonLinkSprite.Update();
// 	}

// }


export interface IPickBonusStartConfig extends IBonusStartConfig
{
	NumOFPickPerPage: number[];
	RequiredElementsToPicks: number[];
}



export interface IPickBonusPickElementFactory
{
	CreatePickElement(params: PickBonusPickElementParams): PickBonusElement;
}

export interface IPickBonusFactory
{
	CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus;
}

export class PickBonusFactory implements IPickBonusFactory, IPickBonusPickElementFactory
{
	public CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus
	{
		return new PickBonus(gameName, params);
	}
	
	
	public CreatePickElement(params: PickBonusPickElementParams): PickBonusElement
	{
		return new PickBonusElement(params);
	}

	public PixiCanvasCrash(): void {
			
	}
}

// class PickBonusFactory_2Screen extends PickBonusFactory
// {
// 	public CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus
// 	{
// 		return new PickBonus_2Screen(gameName, params);
// 	}
	
	
// 	public CreatePickElement(params: PickBonusPickElementParams): PickBonusElement
// 	{
// 		return new PickBonusElement(params);
// 	}
// }





